import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { useViewer } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import CycleMomentSelectorModal from '../packages/kakapo-ui-kit/components/cycles/CycleMomentSelectorModal';
import CreateConversationModal from './CreateConversationModal';
import EvaluationSubmissionRequestModal, {
	EvaluationSubmissionRequestModalMoment,
} from './evaluation-submission/EvaluationSubmissionRequestModal';

export default function ConversationsModals() {
	const viewer = useViewer();

	return (
		<Switch>
			<Route
				path={[
					'/users/:userID/conversations/create-from-moment/:momentID',
					'/users/:userID/conversations/create',
					'/conversations/create',
				]}
				exact
			>
				{({ match }: RouteComponentProps<{ userID?: string; momentID?: string }>) => (
					<CreateConversationModal
						userID={match!.params.userID! ?? viewer?.id}
						momentID={match!.params.momentID}
						returnURL={
							match!.params.momentID
								? `/manager`
								: `/users/${match!.params.userID ?? viewer?.id}/conversations`
						}
					/>
				)}
			</Route>
			<Route path={['/users/:userID/conversations/request', '/conversations/request']} exact>
				{({ match }: RouteComponentProps<{ userID?: string }>) => (
					<EvaluationSubmissionRequestModal
						userID={match!.params.userID! ?? viewer?.id}
						returnURL={`/users/${match!.params.userID ?? viewer?.id}/conversations`}
					/>
				)}
			</Route>
			<Route
				path={[
					'/conversations/request-from-moment',
					'/users/:userID/conversations/request-from-moment',
				]}
				exact
			>
				{({ match }: RouteComponentProps<{ userID?: string; momentID?: string }>) => (
					<CycleMomentSelectorModal
						type={graphql.MomentType.Evaluation}
						regularURL={`/users/${match!.params.userID ?? viewer?.id}/conversations/request`}
						momentURL={(moment) =>
							`/users/${match!.params.userID ?? viewer?.id}/conversations/request-from-moment/${
								moment.id
							}`
						}
						returnURL={
							match?.params.userID
								? `/users/${match!.params.userID ?? viewer?.id}/conversations`
								: '/conversations'
						}
					/>
				)}
			</Route>
			<Route
				path={[
					'/users/:userID/conversations/request-from-moment/:momentID',
					'/conversations/request-from-moment/:momentID',
				]}
				exact
			>
				{({ match }: RouteComponentProps<{ userID?: string; momentID: string }>) => (
					<EvaluationSubmissionRequestModalMoment
						userID={match!.params.userID! ?? viewer?.id}
						returnURL={`/users/${match!.params.userID ?? viewer?.id}/conversations`}
					/>
				)}
			</Route>
		</Switch>
	);
}
